<template>
  <thead>
    <slot></slot>
  </thead>
</template>
